import React from 'react';
import {History} from "react-router";
import Grid from 'core/grid/domain/grid';
import PageAncestor from 'core/common/page/pageAncestor';
import Axios from 'core/common/config/axios-config';
import GridConfig from 'core/grid/domain/gridConfig';
import gridService from 'core/grid/gridService';
import commonService from 'core/common/service/commonService';
import GridAdminComp from 'core/grid/component/gridAdminComp';
import Toolmenu from 'core/components/toolmenu/toolmenu';
import {MODULE, PERMISSION, PageProps} from "core/metamodel/metaConstant";
import {action} from "mobx";
import {observer} from "mobx-react";
import mdEntityService from "core/metamodel/mdEntityService";
import {ZzFlatButton} from "core/components/buttons/buttons";
import {removeItemFromLocalStorage} from "core/common/utils/storage";
import {loc} from "core/common/config/locales";
import ConfirmationDialog from "../components/confirmationDialog/confirmationDialog";


// function mapStateToProps(state, ownProps) {
//   return {
//     entities: state.getIn(['metamodel', 'entities']),
//     gridConfig: state.getIn(['grid', 'gridConfig'])
//   };
// }
//
//
// @connect(mapStateToProps, {updateGridAction, updateGridConfigAction})


@observer
export default class GridConfigDetail extends PageAncestor<PageProps, undefined> {

  static module = MODULE.core;
  static title = 'Manage Grid';
  static icon = 'wrench';
  static protectedPage = true;



  static fetchData(routerParams, query) {
    console.log("GridConfigDetail#fetchData(%o)", routerParams);

    let gridConfigPromise: Promise<GridConfig>;

    let mdEntityPromise = mdEntityService.fetchEntities([{entity: "CONFIGLEVEL", lov: true}, {entity: "GRIDROWCSS", lov: true}, {entity: "Tenant", lov: true}, {entity: "TenantGroup", lov: true}]);

    if (routerParams.id === 'new') {
      gridConfigPromise = gridService.fetchGrids(query.gridLocation)
        .then(gridLocationMap => {
          return GridConfig.newInstance(gridLocationMap.get(query.gridLocation));
        });
    } else if (routerParams.id === 'copy') {
      gridConfigPromise = gridService.readGridConfig(query.copyId)
      .then(gridConfig => {
        gridConfig.cleanOnCopy();
        gridConfig.defaultGrid = undefined;
        return gridConfig;
      });
    } else {
      gridConfigPromise = gridService.readGridConfig(routerParams.id);
    }

    return Promise.all([gridConfigPromise, mdEntityPromise]).then(([gridConfig, entities]) => {
      gridService.gridConfig = gridConfig;
      return gridService.fetchConditionLovs(gridConfig.conditions);
    });
  }



  private gridAdminCompRef: GridAdminComp;


  componentWillUnmount() {
    gridService.gridConfig = undefined;
  }


  /* ****************   EVENT HENDLERS ************************************************************ */


  @action onClickSave = (evt) => {
    console.log('onClickSave');
    this.gridAdminCompRef.save()
      .then((newGridConfig) => {
        if (newGridConfig) {
          this.context.router.replaceWith("gridConfigDetail", {
            gridLocation: newGridConfig.gridLocation,
            id: newGridConfig.gridId
          });
        }
      });
  };

  onClickAdd = (evt) => {
    console.log('onClickAdd');
    this.context.router.transitionTo("gridConfigDetail", {id: 'new'}, {gridLocation: gridService.gridConfig.gridLocation});
  };

  onClickCopy = (evt) => {
    console.log('onClickCopy');
    this.context.router.transitionTo("gridConfigDetail", {id: 'copy'}, {gridLocation: gridService.gridConfig.gridLocation, copyId: gridService.gridConfig.gridId});
  };


  onClickDelete = (evt) => {


    console.log('onClickDelete ' + gridService.gridConfig.gridId);

    this.openDeleteDialog().then(() => {
      commonService.loading(true);

      Axios.delete('/core/grid-config/' + gridService.gridConfig.gridId)
        .then(response => {
          let grid = gridService.getGrid(gridService.gridConfig.gridLocation);
          if (grid) grid.deleteGridConfig(gridService.gridConfig.gridId);
          removeItemFromLocalStorage("GridLocation", loc.lang, gridService.gridConfig.gridLocation);
          this.context.router.transitionTo("gridLocationDetail", {id: gridService.gridConfig.gridLocation});
          commonService.loading(false);
        });
    }).catch((e) => {});
  };

  onClickBack = () => {
    console.log('onClickBack');
    this.context.router.transitionTo("gridLocationDetail", {id: gridService.gridConfig.gridLocation});
  };

  gridAdminCompRefHandler = comp => this.gridAdminCompRef = comp;




  /* ****************   REACT METHODS ************************************************************ */

  render() {

    let toolMenu = this._createToolMenu(gridService.gridConfig, this.props.query.gridLocation);

    console.debug('gridConfigDetail render gridConfig');

    return (
      <main className="main-content container">
      <ConfirmationDialog ref={this.deleteDialogRefHandler} okButtonText={loc.i18n`Yes`} cancelButtonText={loc.i18n`No`}/>
        {toolMenu}
        <GridAdminComp ref={this.gridAdminCompRefHandler} gridLocation={gridService.gridConfig.$gridLocationRef} grid={gridService.getGrid(gridService.gridConfig.gridLocation)}
                       gridConfig={gridService.gridConfig}
                       entities={mdEntityService.entityMap} adminMode={true}/>
      </main>

    );
  }

  /* ****************   NORMAL METHODS ************************************************************ */


  _createToolMenu(gridConfig, gridLocation) {
    return (
      <Toolmenu chainGridLocation={gridLocation} backAction={this.onClickBack} backDisabled={History.length <= 1}>
        { (gridConfig) ? (
          <ZzFlatButton onClick={this.onClickSave} label="Save grid" permission={gridConfig.$new ? PERMISSION.New : PERMISSION.Update}/>
        ) : <noscript/> }
        { (gridConfig && gridConfig.gridId > 0) ? (
          <ZzFlatButton onClick={this.onClickAdd} label="Create new grid" permission={PERMISSION.New}/>
        ) : <noscript/> }
        { (gridConfig && gridConfig.gridId > 0) ? (
          <ZzFlatButton onClick={this.onClickCopy} label="Copy grid" permission={PERMISSION.New}/>
        ) : <noscript/> }
        { (gridConfig && gridConfig.gridId > 0) ? (
          <ZzFlatButton onClick={this.onClickDelete} label="Delete grid" permission={PERMISSION.Delete}/>
        ) : <noscript/> }
      </Toolmenu>
    );
  }


}




// WEBPACK FOOTER //
// ./src/core/grid/gridConfigDetail.tsx